import { HttpErrorResponse } from '@angular/common/http';

export interface StoreResponse<T> {
    status: 'success' | 'error' | string;
    data?: T;
    error?: HttpErrorResponse;
}

export class StoreResponseSuccess<T> implements StoreResponse<T> {
    status = 'success';
    data?: T;

    constructor(data?: T) {
        if (data) {
            this.data = data;
        }
    }
}

export class StoreResponseError implements StoreResponse<HttpErrorResponse> {
    status = 'error';
    error: HttpErrorResponse;

    constructor(error: HttpErrorResponse) {
        this.error = error;
    }
}
